import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, unref as _unref } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "center-title"
}
const _hoisted_2 = {
  key: 0,
  class: "center-title-top"
}
const _hoisted_3 = {
  key: 1,
  class: "center-title-bottom"
}
const _hoisted_4 = {
  key: 1,
  class: "dictionary-item"
}
const _hoisted_5 = { class: "ai-value" }
const _hoisted_6 = {
  key: 2,
  class: "dictionary-item"
}
const _hoisted_7 = { class: "ai-value" }
const _hoisted_8 = {
  key: 0,
  class: "ai-tip"
}
const _hoisted_9 = {
  key: 3,
  class: "dictionary-item"
}
const _hoisted_10 = { class: "ai-value" }
const _hoisted_11 = {
  key: 0,
  class: "ai-tip"
}
const _hoisted_12 = {
  key: 4,
  class: "dictionary-item"
}
const _hoisted_13 = { class: "ai-value" }
const _hoisted_14 = {
  key: 0,
  class: "ai-tip"
}
const _hoisted_15 = {
  key: 5,
  class: "dictionary-item"
}
const _hoisted_16 = { class: "word-examples" }
const _hoisted_17 = { class: "ai-value" }
const _hoisted_18 = { class: "ai-tip" }
const _hoisted_19 = {
  key: 6,
  class: "dictionary-item"
}
const _hoisted_20 = { class: "word-examples" }
const _hoisted_21 = { class: "example-item-detail" }
const _hoisted_22 = { class: "audio-com" }
const _hoisted_23 = ["onClick", "src"]
const _hoisted_24 = { class: "ai-value" }
const _hoisted_25 = { class: "ai-tip" }
const _hoisted_26 = {
  key: 1,
  class: "no-ai-data"
}

import { computed, onBeforeUnmount, onMounted, ref, watch } from "vue";
import { useRoute } from "vue-router";
import { useBasicLayout } from "@/hooks/useBasicLayout";
import { ai_dictionary_Regexp_list } from "@/views/AIGenerate/smartReading/defaultData";
import { modalController } from "@ionic/vue";
import { handleDecodeUrlComponentStr } from "@/views/AIGenerate/smartReading/commonMethod";
import { audioPlayStream } from "@/js/common";
import AudioComp from "@/views/AIGenerate/components/AudioComp.vue";
import { getBrandImageUrl } from "@/js/brandImages";
import SmartAnalysis from "@/views/AIGenerate/smartAnalysis/smartAnalysis.vue";
import RootsAndAffixes from "@/views/AIGenerate/components/RootsAndAffixes.vue";

interface Props {
  inversion?: boolean;
  error?: boolean;
  text?: Object;
  loading?: boolean;
  asRawText?: boolean;
  propWord?: string;
  show?: boolean;
  learnType?: string;
  fontStyle?: Record<string, any>;
  articleText?: string;
  generateType?: string;
}

interface DictionaryData {
  单词?: string;
  音标?: string;
  中文?: string;
  常用搭配?: Array<{
    短语: string;
    翻译: string;
  }>;
  经典例句?: Array<{
    例句: string;
    翻译: string;
  }>;
  词根?: string;
  词根描述?: string;
  词根例词?: Array<{
    单词: string;
    翻译: string;
  }>;
  前缀?: string;
  前缀描述?: string;
  前缀例词?: Array<{
    单词: string;
    翻译: string;
  }>;
  后缀?: string;
  后缀描述?: string;
  后缀例词?: Array<{
    单词: string;
    翻译: string;
  }>;
  词缀?: string; // 添加词缀字段
}


export default /*@__PURE__*/_defineComponent({
  __name: 'TextDictionary',
  props: {
    inversion: { type: Boolean },
    error: { type: Boolean },
    text: {},
    loading: { type: Boolean },
    asRawText: { type: Boolean },
    propWord: {},
    show: { type: Boolean },
    learnType: {},
    fontStyle: {},
    articleText: {},
    generateType: {}
  },
  setup(__props: any, { expose: __expose }) {

const gotoIcon = getBrandImageUrl("ai_smart_reading/analysis_icon.svg");
const props = __props;
const route = useRoute();
const { isMobile } = useBasicLayout();
const gptStr = ref("");
const studentInfo = ref();
const audioPlayer = ref();
const mediaType = ref();
const dictionaryData = ref<DictionaryData | any>({});

const textRef = ref<HTMLElement>();

const textBlack = ref<any>();
const bofangIcon = ref<Record<string, string>>({});
const timer = ref(0);
const dicObj = ref<Record<string, any>>({});

watch(
  () => props.text,
  (newVal) => {
    if (newVal) {
      try {
        dictionaryData.value = { ...newVal };
      } catch (e) {
        console.error("Failed to parse dictionary data:", e);
      }
    }
  },
  { immediate: true }
);

const loading = computed(() => props.loading);

const wrapClass = computed(() => {
  return [
    "text-wrap",
    "min-w-[20px]",
    "rounded-md",
    isMobile.value ? "p-2" : "px-3 py-2",
    props.inversion ? "bg-[#d2f9d1]" : "bg-[#f4f6f8]",
    props.inversion ? "dark:bg-[#a1dc95]" : "dark:bg-[#1e1e20]",
    props.inversion ? "message-request" : "message-reply",
    { "text-red-500": props.error },
  ];
});
const text = computed(() => {
  // 给文章添加标题并首行居中显示
  let value;
  if (props.generateType === "vocabulary") {
    value = props.text ?? "";
  } else {
    value = "# " + props.text ?? "";
  }
  if (!props.asRawText) {
    value = value.replace(/句子\n/g, "句子:");
    value = value.replace(/句子[:：]\n/g, "句子:");
    return mdi.render(value);
  }
  return value;
});

async function gotoAnalysis(value: string) {
  const modal = await modalController.create({
    component: SmartAnalysis,
    componentProps: { question: value },
    backdropDismiss: false,
    cssClass: "modal_controller_class",
  });
  await modal.present();
  const { data } = await modal.onDidDismiss();
  if ("cancel" === data) {
    await modal.dismiss();
  }
}

function getEnByCn(cn: string) {
  const item = ai_dictionary_Regexp_list.find((i) => cn.includes(i.cn));
  if (item) {
    return item.en;
  } else {
    return "";
  }
}

// 暂停播放
function pauseAudio(id?: string) {
  if (audioPlayer.value) {
    if (mediaType.value === "MEDIA_SOURCE") {
      audioPlayer.value.pause();
      audioPlayer.value = null;
    } else if (mediaType.value === "AUDIO_CONTEXT") {
      audioPlayer.value.close();
      audioPlayer.value = null;
    }
  }
  if (id) {
    bofangIcon.value[id] = "icon-bofang3";
    setElementClass(id, "icon-bofang3");
  } else {
    bofangIcon.value = {};
  }
  clearInterval(timer.value);
}

// 设置播放按钮元素类名
function setElementClass(id: string, value: string) {
  const el = document.querySelector(`#${id}`);
  const classList = el?.classList;
  classList?.remove("icon-bofang3", "icon-bofang2", "icon-bofang1");
  classList?.add(value);
}

// 播放音频
function streamAudioPlay(txt: string, id: string) {
  // 关闭音频
  pauseAudio(id);

  audioPlayStream(txt, (callbackData: any, type: string) => {
    mediaType.value = type;
    let num = 0;
    if (mediaType.value === "MEDIA_SOURCE") {
      audioPlayer.value = new Audio(callbackData);
      audioPlayer.value.oncanplay = function () {
        audioPlayer.value.play();
      };
      audioPlayer.value.onended = function () {
        console.log("ended");
        pauseAudio(id);
      };
      audioPlayer.value.oncanplaythrough = () => {
        console.log("loading");
        clearInterval(timer.value);
        timer.value = window.setInterval(() => {
          num = ++num % 3;
          bofangIcon.value[id] = `icon-bofang${num + 1}`;
          setElementClass(id, `icon-bofang${num + 1}`);
        }, 300);
      };
    } else if (mediaType.value === "AUDIO_CONTEXT") {
      audioPlayer.value = callbackData;
    }
  });
}

async function clickRootOrAffix(name: any) {
  if (!dictionaryData.value[name + "例词"].length) {
    return;
  }
  const modal = await modalController.create({
    component: RootsAndAffixes,
    componentProps: {
      name: name + "串记",
      resJson: {
        wordRoot: dictionaryData.value[name],
        words: dictionaryData.value[name + "例词"],
        rootphonetic: dictionaryData.value[name + "音标"],
        rootchinesedefinition: dictionaryData.value.中文,
      },
    },
    initialBreakpoint: 0.6,
    cssClass: "down_modal_class",
  });
  await modal.present();
  const { data } = await modal.onDidDismiss();
  if (data === "cancel") {
    await modal.dismiss();
  }
}

onMounted(() => {
  //获取路由参数
  studentInfo.value = handleDecodeUrlComponentStr(route.params.studentInfo);
  console.log(dicObj.value);
});

onBeforeUnmount(() => {
  console.log("onBeforeUnmount");
  pauseAudio();
});

//对外部暴露函数
__expose({
  textBlack,
  pauseAudio,
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["text-black", wrapClass.value])
  }, [
    _createElementVNode("div", {
      ref_key: "textRef",
      ref: textRef,
      class: "leading-relaxed break-words"
    }, [
      (dictionaryData.value.音标 && dictionaryData.value.音标 && dictionaryData.value.中文)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            ref_key: "textBlack",
            ref: textBlack,
            "scroll-events": true,
            "overflow-scroll": true,
            scroll: true
          }, [
            _createElementVNode("div", {
              class: _normalizeClass(["markdown-body4", { 'common-markdown': props.generateType === 'vocabulary' }])
            }, [
              (dictionaryData.value.单词 || dictionaryData.value.音标)
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                    (dictionaryData.value.单词)
                      ? (_openBlock(), _createElementBlock("h1", _hoisted_2, _toDisplayString(dictionaryData.value.单词), 1))
                      : _createCommentVNode("", true),
                    (dictionaryData.value.音标)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                          _createTextVNode(" [" + _toDisplayString(dictionaryData.value.音标) + "] ", 1),
                          _createVNode(AudioComp, {
                            word: dictionaryData.value.单词 || '',
                            color: "#101214"
                          }, null, 8, ["word"])
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              (dictionaryData.value.中文)
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                    _cache[3] || (_cache[3] = _createElementVNode("span", { class: "normal-title" }, "中文", -1)),
                    _createElementVNode("span", _hoisted_5, _toDisplayString(dictionaryData.value.中文), 1)
                  ]))
                : _createCommentVNode("", true),
              (dictionaryData.value.词根 && dictionaryData.value.词根例词.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    _createElementVNode("div", {
                      class: "ai-value-root",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (clickRootOrAffix('词根')))
                    }, [
                      _createElementVNode("span", {
                        class: _normalizeClass(["ai-button", { 'ai-button-disabled': !dictionaryData.value.词根例词.length }]),
                        id: "ai-button-root",
                        "data-text": "词根"
                      }, "词根", 2),
                      _createElementVNode("span", _hoisted_7, _toDisplayString(dictionaryData.value.词根), 1),
                      (dictionaryData.value.词根描述)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(dictionaryData.value.词根描述), 1))
                        : _createCommentVNode("", true)
                    ])
                  ]))
                : _createCommentVNode("", true),
              (dictionaryData.value.前缀 && dictionaryData.value.前缀例词.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                    _createElementVNode("div", {
                      class: "ai-value-affix",
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (clickRootOrAffix('前缀')))
                    }, [
                      _createElementVNode("span", {
                        class: _normalizeClass(["ai-button", { 'ai-button-disabled': !dictionaryData.value.前缀例词.length }]),
                        id: "ai-button-affix",
                        "data-text": "前缀"
                      }, "前缀", 2),
                      _createElementVNode("span", _hoisted_10, _toDisplayString(dictionaryData.value.前缀), 1),
                      (dictionaryData.value.前缀描述)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(dictionaryData.value.前缀描述), 1))
                        : _createCommentVNode("", true)
                    ])
                  ]))
                : _createCommentVNode("", true),
              (dictionaryData.value.后缀 && dictionaryData.value.后缀例词.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                    _createElementVNode("div", {
                      class: "ai-value-affix",
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (clickRootOrAffix('后缀')))
                    }, [
                      _createElementVNode("span", {
                        class: _normalizeClass(["ai-button", { 'ai-button-disabled': !dictionaryData.value.后缀例词.length }]),
                        id: "ai-button-affix",
                        "data-text": "后缀"
                      }, "后缀", 2),
                      _createElementVNode("span", _hoisted_13, _toDisplayString(dictionaryData.value.后缀), 1),
                      (dictionaryData.value.后缀描述)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(dictionaryData.value.后缀描述), 1))
                        : _createCommentVNode("", true)
                    ])
                  ]))
                : _createCommentVNode("", true),
              (dictionaryData.value.常用搭配?.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                    _cache[4] || (_cache[4] = _createElementVNode("span", { class: "special-title" }, "常用搭配", -1)),
                    _createElementVNode("div", _hoisted_16, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dictionaryData.value.常用搭配, (item, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: index,
                          class: "example-item"
                        }, [
                          _createElementVNode("span", _hoisted_17, _toDisplayString(item.短语), 1),
                          _createElementVNode("span", _hoisted_18, _toDisplayString(item.翻译), 1)
                        ]))
                      }), 128))
                    ])
                  ]))
                : _createCommentVNode("", true),
              (dictionaryData.value.经典例句?.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                    _cache[5] || (_cache[5] = _createElementVNode("span", { class: "special-title" }, "经典例句", -1)),
                    _createElementVNode("div", _hoisted_20, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dictionaryData.value.经典例句, (item, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: index,
                          class: "example-item"
                        }, [
                          _createElementVNode("div", _hoisted_21, [
                            _createElementVNode("div", _hoisted_22, [
                              _createVNode(AudioComp, {
                                word: item.例句 || '',
                                color: "#101214"
                              }, null, 8, ["word"])
                            ]),
                            _createElementVNode("img", {
                              class: "goto-icon",
                              onClick: ($event: any) => (gotoAnalysis(item.例句)),
                              src: _unref(gotoIcon),
                              alt: ""
                            }, null, 8, _hoisted_23),
                            _createElementVNode("span", _hoisted_24, _toDisplayString(item.例句), 1)
                          ]),
                          _createElementVNode("div", _hoisted_25, _toDisplayString(item.翻译), 1)
                        ]))
                      }), 128))
                    ])
                  ]))
                : _createCommentVNode("", true)
            ], 2)
          ], 512))
        : _createCommentVNode("", true),
      (!(dictionaryData.value.音标 && dictionaryData.value.音标 && dictionaryData.value.中文) && !loading.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_26, " 抱歉，没有找到相关信息。 "))
        : _createCommentVNode("", true)
    ], 512)
  ], 2))
}
}

})